import { useMemo } from 'react';
import { useIntl } from 'react-intl';

export const MORE_OPTIONS_ID = 'more-data-available-option';

export const useMoreMessage = (label?: string | null): any => {
  const { formatMessage } = useIntl();
  const moreLabel = formatMessage({
    id: `settings.groups.moreLabels.${label}`
  });
  const message = useMemo(
    () =>
      ({
        id: MORE_OPTIONS_ID,
        displayText: formatMessage(
          { id: 'settings.more.optionsText' },
          {
            label: moreLabel
          }
        ),
        level: 0
      } as any),
    [formatMessage, moreLabel]
  );
  return { ...message };
};
